import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import ListGrid from '../../common/components/ListGrid/ListGrid';
import TableWrapper from '../../common/components/TableWrapper/TableWrapper';
import ListActions from '../../common/components/ListActions';
import Title from '../../common/components/Title';
import {OrdersBundle} from "../../utils/ordersBundle";
import AuditTable from "./AuditTable";
import {Input} from "@mui/material";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { hetch } from "../../utils/fetch.hooked";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ruLocale from "date-fns/locale/ru";
import DpIcon from '@mui/icons-material/CalendarMonth';
import {NewFiltersBundle} from "../../utils/newFiltersBundle";

function Audit({ permission }) {
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const [isFetching, setIsFetching] = useState(false);
    const [refetch, setRefetch] = useState(false);
    const [page, setPage] = useState(query.get('pageNumber') ?? 1);
    const [count, setCount] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [rows, setRows] = useState(null);
    const [sortOrders, setSortOrders] = useState('[{"fieldName": "id", "sortMode": "desc"}]');
    const [filterFields, setFilterFields] = useState('');

    const ordersBundle = new OrdersBundle({
            id: { firstDirection: 'asc', direction: useState('desc'), index: useState(1) },
            ctime: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
            actionType: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
            dataType: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
            changedByUser: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        },
        sortOrders, setSortOrders
    )
    const filterBundle = new NewFiltersBundle({
        actionType: useState(''),
        changedByUser: useState(''),
        ctimeMax: useState(null),
        ctimeMin: useState(null),
        dataType: useState(''),
        idMax: useState(''),
        idMin: useState(''),
        oldNewData: useState(''),
    }, filterFields, setFilterFields)

    const triggerRefetch = () => setRefetch(refetch => !refetch);
    const buildSearchParams = () => {
        let p = {
            pageNumber: page,
            pageSize: pageSize,
        };
        if (sortOrders.length > 0) {
            p.orderBy = (JSON.parse(sortOrders ?? '[]')).map((p) => `${p.fieldName}:${p.sortMode}`).join(',');
        }
        p = { ...p, ...filterFields }
        return new URLSearchParams(p).toString();
    }

    useEffect(() => {
        history.push({
            search: `pageNumber=${page}`
        })
    }, [history, page]);

    useEffect(() => {
        const fetchData = () => {
            setIsFetching(true);
            hetch(`/api/common_audit?` + buildSearchParams())
                .then(res => res.json())
                .then((auditRes) => {
                    setRows(auditRes?.data ?? []);
                    setCount(Math.ceil(auditRes.total / auditRes.pageSize));
                })
                .finally(() => {
                    setIsFetching(false);
                });
        }

        fetchData();
    }, [page, pageSize, sortOrders, filterFields, refetch]);

    const defaultWidth = undefined;
    const [idColWidth, setIdColWidth] = useState(defaultWidth);
    const [dateWidth, setDateWidth] = useState(defaultWidth);
    const [actionTypeWidth, setActionTypeWidth] = useState(defaultWidth);
    const [dataTypeWidth, setDataTypeWidth] = useState(defaultWidth);
    const [changedByUserWidth, setChangedByUserWidth] = useState(defaultWidth);
    const [oldNewDataWidth, setOldNewDataWidth] = useState(defaultWidth);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setIdColWidth((document.querySelector('#idHead')?.clientWidth) ?? defaultWidth);
            setDateWidth((document.querySelector('#dateHead')?.clientWidth) ?? defaultWidth);
            setActionTypeWidth((document.querySelector('#actionTypeHead')?.clientWidth - 17) ?? defaultWidth);
            setDataTypeWidth((document.querySelector('#dataTypeHead')?.clientWidth - 17) ?? defaultWidth);
            setChangedByUserWidth((document.querySelector('#userHead')?.clientWidth - 17) ?? defaultWidth);
            setOldNewDataWidth((document.querySelector('#descriptionHead')?.clientWidth - 17) ?? defaultWidth);
        }, 300);
        return () => clearInterval(intervalId);
    }, []);

    const handleChange = (event, value) => {
        setPage(value);
    };
    const limitLength = (str, maxLength) => str.length > maxLength ? str.substring(0, maxLength) : str;
    const stripNN = (str, maxLength) => {
        str = str.replace(/\D+/g, '');
        return str.length > maxLength ? str.substring(0, maxLength) : str;
    }
    const applyDate = (field, date) => {
        try {
            filterBundle.setFilter(field, date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0] : null);
        } catch (e) {
            filterBundle.setFilter(field, date);
        }
        return date;
    }
    return (
        <>
            <ListGrid
                header={(
                    <>
                    <Title
                        title="Журнал событий"
                        actions={(
                            <ListActions
                                refreshTitle="Обновить журнал событий"
                                permission={permission}
                                isRefreshing={isFetching}
                                onRefreshClick={() => triggerRefetch(refetch => !refetch)}
                                pageSizes={[25, 50, 100]}
                                pageSize={pageSize}
                                onPageSizeChange={(size) => { setPage(1); setPageSize(size) } }
                            />
                        )}
                    />
                    </>
                )}
                body={(
                    <>

                        <TableWrapper
                            rows={rows}
                            count={count}
                            page={page}
                            emptyAlertText="Журнал сеансов пуст"
                            isFetching={isFetching}
                            onChange={handleChange}
                            filter={
                                <div id={'idFilter'} style={{padding: '0 0 8px'}}>
                                    <span style={{padding: '0 8px', display: "inline-block", width: idColWidth+'px'}}>
                                        <Input style={{display: 'inline-block', width: '49%', fontSize: '0.75em' }} placeholder={"от"}
                                               onChange={(e) => filterBundle.setFilter('idMin', stripNN(e.target.value, 21))}
                                               value={filterBundle.getFilter('idMin').value}/>
                                        <Input style={{display: 'inline-block', width: '49%', fontSize: '0.75em', marginInlineStart: '2%' }} placeholder={"до"}
                                               onChange={(e) => filterBundle.setFilter('idMax', stripNN(e.target.value, 21))}
                                               value={filterBundle.getFilter('idMax').value}/>
                                    </span>
                                    <span style={{padding: '0 8px', display: "inline-block", width: dateWidth+'px'}}>
                                        <LocalizationProvider localeText={{
                                            clearButtonLabel: 'Очистить',
                                            previousMonth: 'Предыдущий месяц',
                                            nextMonth: 'Следующий месяц',
                                            openNextView: 'Следующее',
                                            openPreviousView: 'Предыдущее',
                                        }} adapterLocale={ruLocale} dateAdapter={AdapterDateFns}>
                                            <DateTimePicker
                                                timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                                                minutesStep={1}
                                                views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                                                ampmInClock={false}
                                                hideTabs={false}
                                                ampm={false}
                                                showToolbar={true}
                                                inputFormat="dd.MM.yyyy HH:mm:ss"
                                                onChange={ (e) => applyDate('ctimeMin', e) }
                                                value={filterBundle.getFilter('ctimeMin').value}
                                                componentsProps={ { actionBar: { actions: ['clear'] } } }
                                                components={ { OpenPickerIcon: () => (<DpIcon fontSize='small' />) } }
                                                renderInput={
                                                    (params) => {
                                                        params.inputProps.style = { fontSize: '0.75em', display: 'inline-block' };
                                                        params.inputProps.placeholder = 'от';
                                                        return (
                                                            <TextField style={{display: 'inline-block', width: '49%' }} {...params} placeholder={'от'} variant="standard" size={'small'} />
                                                        );
                                                    }
                                                }
                                            />
                                            <DateTimePicker
                                                timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                                                minutesStep={1}
                                                views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                                                ampmInClock={false}
                                                hideTabs={false}
                                                showToolbar={true}
                                                ampm={false}
                                                inputFormat="dd.MM.yyyy HH:mm:ss"
                                                onChange={ (e) => applyDate('ctimeMax', e) }
                                                value={filterBundle.getFilter('ctimeMax').value}
                                                componentsProps={ { actionBar: { actions: ['clear'] } } }
                                                components={ { OpenPickerIcon: () => (<DpIcon fontSize='small' />) } }
                                                renderInput={
                                                    (params) => {
                                                        params.inputProps.style = { fontSize: '0.75em', display: 'inline-block' };
                                                        params.inputProps.placeholder = 'до';
                                                        return (
                                                            <TextField disabled={true} style={{display: 'inline-block', width: '49%', marginInlineStart: '2%' }} {...params} placeholder={'от'} variant="standard" size={'small'} />
                                                        );
                                                    }
                                                }
                                            />
                                        </LocalizationProvider>
                                    </span>
                                    <span style={{padding: '0 8px'}}>
                                        <Input style={{width: actionTypeWidth+'px', fontSize: '0.75em'}} placeholder={"Тип события"}
                                               onChange={(e) => filterBundle.setFilter('actionType', limitLength(e.target.value, 255))}
                                               value={filterBundle.getFilter('actionType').value}/>
                                    </span>
                                    <span style={{padding: '0 8px'}}>
                                        <Input style={{width: dataTypeWidth+'px', fontSize: '0.75em'}} placeholder={"Тип данных"}
                                               onChange={(e) => filterBundle.setFilter('dataType', limitLength(e.target.value, 255))}
                                               value={filterBundle.getFilter('dataType').value}/>
                                    </span>
                                    <span style={{padding: '0 8px'}}>
                                        <Input style={{width: changedByUserWidth+'px', fontSize: '0.75em'}} placeholder={"Логин"}
                                               onChange={(e) => filterBundle.setFilter('changedByUser', limitLength(e.target.value, 255))}
                                               value={filterBundle.getFilter('changedByUser').value}/>
                                    </span>
                                    <span style={{padding: '0 8px'}}>
                                        <Input style={{width: oldNewDataWidth+'px', fontSize: '0.75em'}} placeholder={"Описание события"}
                                               onChange={(e) => filterBundle.setFilter('oldNewData', limitLength(e.target.value, 255))}
                                               value={filterBundle.getFilter('oldNewData').value}/>
                                    </span>
                                </div>
                            }
                        >
                            <>
                                <AuditTable filterBundle={filterBundle}
                                            ordersBundle={ordersBundle} permission={permission}
                                            rows={rows} triggerRefetch={triggerRefetch}/>
                            </>
                        </TableWrapper>
                    </>
                )}
            />
        </>
    );
}

export default Audit;
